import { configureStore } from "@reduxjs/toolkit";
import medicalReducer from './medicalSlice'
import identityReducer from './identitySlice'

export default configureStore({
  reducer: {
    medical: medicalReducer,
    identity: identityReducer,
  }
})
